import { put, take, fork } from 'redux-saga/effects'
import { ASSIGNMENT_REMOVE_USER } from '../../reducers/assignment/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* assignmentRemoveUserFLow(payload) {
  try {
    const { callback } = payload
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail())
  }
}

/**
 *
 */
export default function* assignmentRemoveUserWatcher() {
  while (true) {
    const action = yield take(ASSIGNMENT_REMOVE_USER)
    const { payload } = action

    yield fork(generalSaga, assignmentRemoveUserFLow, payload)
  }
}
